import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { ProposalComment } from "src/redux/projects";
import { createModal } from "react-modal-promise";

interface Props {
  comment: ProposalComment;
  open: boolean;
  close: () => void;
}

type PropsWithNamespaces = Props & WithNamespaces;

class CommentModalLocked extends React.Component<PropsWithNamespaces> {
  render() {
    /* This modal should be in a promise, so it's always open */
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.props.close}
        className="comment-modal comment-modal-locked"
      >
        <ModalHeader toggle={this.props.close}>
          <span className="flex-1">{this.props.t("commentModal.title")}</span>
        </ModalHeader>
        <ModalBody>
          <textarea
            className="comment-modal-textarea"
            placeholder="..."
            value={this.props.comment.text}
          />
          {this.props.comment.files && (
            <div>
              {this.props.comment.files.length > 0 && (
                <div>
                  <p className=" mt-2 mb-2">
                    {this.props.t("proposal.files.title")}
                  </p>
                  <div>
                    {this.props.comment.files.map(file => (
                      <div className="d-flex" key={file.id}>
                        <a className="flex-1" target="_blank" href={file.url}>
                          <img
                            width="16px"
                            src="assets/svgs/outline-cloud_download.svg"
                          />
                          <small className="ml-2">{file.filename}</small>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default createModal(withNamespaces()(CommentModalLocked));



// WEBPACK FOOTER //
// ./src/components/CommentModalLocked.tsx